"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsOverflowed = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useIsOverflowed = function useIsOverflowed(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$callback = _ref.callback,
      callback = _ref$callback === void 0 ? function () {} : _ref$callback,
      _ref$updateOnWindowRe = _ref.updateOnWindowResize,
      updateOnWindowResize = _ref$updateOnWindowRe === void 0 ? true : _ref$updateOnWindowRe;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOverflowed = _useState2[0],
      setIsOverflowed = _useState2[1];

  var listener = (0, _react.useCallback)(function () {
    var dispatch = function dispatch() {
      var checkOverflow = ref.current.scrollHeight > ref.current.clientHeight;
      setIsOverflowed(checkOverflow);
      callback(checkOverflow);
    };

    if (ref.current != null) {
      dispatch();
    }
  }, [callback, ref]);
  (0, _react.useLayoutEffect)(function () {
    listener();
    updateOnWindowResize && window.addEventListener('resize', listener); // re-assess overflow on resize

    return function () {
      return updateOnWindowResize && window.removeEventListener('resize', listener);
    }; // cleanup function
  }, [callback, listener, ref, updateOnWindowResize]);
  return isOverflowed;
};

exports.useIsOverflowed = useIsOverflowed;
//# sourceMappingURL=use-is-overflowed.js.map